import { AbstractTicketSymbolProperties } from "@lib/titan2-slingo/dist/game/view/abstract/properties/AbstractTicketSymbolProperties";
import { SpineProperties } from "@lib/titan2/dist/game/control/properties/SpineProperties";
import { Point } from "pixi.js";
import { deepEquals } from "../../../utils/deepEquals";
import { GameStyle } from "../style/GameStyle";
/**
 * Game-specific ticket symbol properties.
 */
export class GameTicketSymbolProperties extends AbstractTicketSymbolProperties {
    constructor() {
        super(...arguments);
        this.size = new Point(180, 180);
        this.dabSpineProperties = new SpineProperties(GameStyle.TICKET_SYMBOL_DAB, GameStyle.MODULE);
        this.dabTrailSpineProperties = [
            new SpineProperties(GameStyle.DAB_TRAIL_SHORT, GameStyle.MODULE),
            new SpineProperties(GameStyle.DAB_TRAIL_MEDIUM, GameStyle.MODULE),
            new SpineProperties(GameStyle.DAB_TRAIL_LONG, GameStyle.MODULE)
        ];
        this.dabTrailGlowDistance = 20;
        this.dabTrailGlowStrength = 5;
        this.dabTrailColours = GameStyle.FREE_SPIN_TRAIL_GLOW.colours;
        this.transitionStagger = 50;
    }
    equals(other) {
        return deepEquals(other, this);
    }
}
//# sourceMappingURL=GameTicketSymbolProperties.js.map